<template>
  <div class="row no-gutters noprint">
    <div class="col-md-9 col-12 my-3">
          <span @click="navigateToHome" class="solution-link">
            <font-awesome-icon icon="arrow-left" size="sm"/>
            Go to Supplier Central home
          </span>
    </div>
  </div>
</template>

<script>
import PaymentFormsMixin from "@/mixins/PaymentFormsMixin";

export default {
  name: "BackToHomePageButton",
  mixins:[PaymentFormsMixin]

}
</script>

<style scoped>

</style>